import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { heroContentAPI } from '../../services/api';

export const fetchHeroContent = createAsyncThunk('heroContent/fetchAll', async (params, { rejectWithValue }) => {
  try {
    const response = await heroContentAPI.getAll(params);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch hero content');
  }
});

export const createHeroContent = createAsyncThunk('heroContent/create', async (data, { rejectWithValue }) => {
  try {
    const response = await heroContentAPI.create(data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to create hero content');
  }
});

export const updateHeroContent = createAsyncThunk('heroContent/update', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await heroContentAPI.update(id, data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to update hero content');
  }
});

export const deleteHeroContent = createAsyncThunk('heroContent/delete', async (id, { rejectWithValue }) => {
  try {
    await heroContentAPI.delete(id);
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to delete hero content');
  }
});

const heroContentSlice = createSlice({
  name: 'heroContent',
  initialState: { heroContent: [], loading: false, error: null, pagination: null },
  reducers: { clearError: (state) => { state.error = null; } },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHeroContent.pending, (state) => { state.loading = true; })
      .addCase(fetchHeroContent.fulfilled, (state, action) => {
        state.loading = false;
        state.heroContent = action.payload.data || [];
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchHeroContent.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createHeroContent.fulfilled, (state, action) => { state.heroContent.unshift(action.payload); })
      .addCase(updateHeroContent.fulfilled, (state, action) => {
        const index = state.heroContent.findIndex(h => h.id === action.payload.id);
        if (index !== -1) state.heroContent[index] = action.payload;
      })
      .addCase(deleteHeroContent.fulfilled, (state, action) => {
        state.heroContent = state.heroContent.filter(h => h.id !== action.payload);
      });
  },
});

export const { clearError } = heroContentSlice.actions;
export default heroContentSlice.reducer;
